import React, {Component} from "react";
import {Select} from "antd";
import {CONFIGURATION_TYPE} from "../config/paramConfiguration";

const {Option} = Select;

export default class TypeSelect extends Component {
    render() {
        const {allowClear = false, disabled, placeholder} = this.props;
        return (
            <Select
                value={this.props.value||undefined}
                disabled={disabled}
                onChange={(e) => this.props.onChange(e)}
                style={this.props.style}
                allowClear={allowClear}
                placeholder={placeholder}
            >
                {
                    CONFIGURATION_TYPE.map(item => {
                        return <Option key={item.value} value={item.value}>{item.label}</Option>;
                    })
                }
            </Select>
        );
    }
}

